export function userId() {
    const token = window.sessionStorage.getItem("token")
    const info = atob(token!.split(".")[1])
    return JSON.stringify(JSON.parse(info).sub, null, 2)
}